
import { defineComponent } from 'vue'
import ScrollParallax from 'vue3-parallax/src/components/ScrollParallax.vue'

import BackgroundImage from '@/components/Common/BackgroundImage.vue'
import Quote from '@/components/Common/Quote.vue'
import Animate from '@/components/Common/Animate.vue'

export default defineComponent({
    name: 'Idea-Vision',
    components: {
        ScrollParallax,
        BackgroundImage,
        Quote,
        Animate,
    },
})
